import { getCurrentInstance, ref } from 'vue';
import {
  useFlag as useUnleashFlag,
  useUnleashClient,
} from '@unleash/proxy-client-vue';
import type { Flags } from '~/constants/featureFlags';

export default function useFlag(flagName: Flags) {
  if (!flagName) {
    return ref(false);
  }

  const config = useRuntimeConfig();
  const flagsOverrides = config.public.unleash.flagsOverride || [];

  if (import.meta.env.DEV && flagsOverrides.includes(flagName)) {
    return ref(true);
  }

  const flagsDisabledOverrides =
    config.public.unleash.flagsDisabledOverride || [];
  if (import.meta.env.DEV && flagsDisabledOverrides.includes(flagName)) {
    return ref(false);
  }

  // Route middleware runs outside of a component setup, so Unleash's
  // useFlag (which registers an onUnmounted listener) cannot be used there.
  if (!getCurrentInstance()) {
    const client = useUnleashClient();
    return ref(client?.isEnabled(flagName) ?? false);
  }

  return useUnleashFlag(flagName);
}
